/**
 * Site-wide constants for the public (static) site.
 *
 * The hosted product surface — accounts, the web app, the chat assistant and the
 * hosted MCP endpoints — was retired in September 2026. What remains is a landing
 * page and the blog. Every call to action points at pm-skills, the portable
 * project-management skills that came out of Kaibernetic, because that is the part
 * a visitor can actually pick up and use (decided 2026-09-21). The product
 * repository stays private and is no longer maintained.
 */
export const GITHUB_URL = 'https://github.com/davidoj/pm-skills';

export const SITE_URL = 'https://kaibernetic.ai';

/** Contact for former users who want a copy of their exported data. */
export const SUPPORT_EMAIL = 'support@kaibernetic.ai';

/** Month the hosted service closed; shown on the retirement notices. */
export const RETIRED_WHEN = 'September 2026';
